import { ROWS, COLS } from '../core/constants.js';

export { getMatchingPieces };

function findMatches(board, row, col, rowDelta, colDelta) {
  const matches = [];
  const piece = board.getPiece(row, col);
  if (!piece) return matches;

  while (true) {
    row += rowDelta;
    col += colDelta;
    if (row < 0 || row >= ROWS || col < 0 || col >= COLS) {
      break;
    }
    const nextPiece = board.getPiece(row, col);
    if (nextPiece && piece && nextPiece.color === piece.color) {
      matches.push(nextPiece);
    } else {
      break;
    }
  }
  return matches;
}

function checkMatches(board, piece, matches, row, col, rowDelta, colDelta) {
  const foundMatches = [
    piece,
    ...findMatches(board, row, col, rowDelta, colDelta),
    ...findMatches(board, row, col, -1 * rowDelta, -1 * colDelta),
  ];
  if (foundMatches.length >= 3) {
    matches.push(...foundMatches);
  }
  return matches;
}

/**
 * 指定ピースに対してマッチするピース群を取得
 * @param {Object} board - ゲームボードインスタンス
 * @param {Object} piece - チェック対象のピース
 * @returns {Array} マッチしたピースの配列（重複除去済み）
 */
function getMatchingPieces(board, piece) {
  if (!piece) return [];
  if (piece.specialType) return [];

  const [row, col] = piece.position;
  let matches = [];

  matches = checkMatches(board, piece, matches, row, col, 1, 0);
  matches = checkMatches(board, piece, matches, row, col, 0, 1);

  if (matches.length > 0) {
    return [...new Set(matches)];
  }

  return [];
}
